import Title from "antd/es/typography/Title"
import PageHeader from "modules/layout/dashboard/main/page-header"
import { useTranslation } from "react-i18next"
import { useSubstitutionRequests } from "./queries"
import Loader from "components/loader"
import { Button, Empty, Space, Tag } from "antd"
import OverviewCardWithDate from "components/overview-card-with-date"
import { ReactComponent as CheckIcon } from "assets/icons/check.svg"
import { ReactComponent as DeleteIcon } from "assets/icons/delete.svg"
import { ISubstitutionRequest } from "./types"
import { usePopup } from "utils/use-popup"
import ApplyToSubstituteModal from "./apply"
import DeleteSubstitutionApplicationModal from "./delete"

const statusTagColors = (status: ISubstitutionRequest["application"]) => {
  switch (status) {
    case "new":
      return "var(--color-primary)"
    case "applied":
      return "var(--color-accent2)"
    case "accepted":
      return "var(--color-success)"
    case "refused":
      return "var(--color-error)"
    default:
      return "var(--color-primary)"
  }
}

const SubstitutionRequests = () => {
  const { t } = useTranslation()
  const { data, isLoading } = useSubstitutionRequests()

  const applyToSubstituteModal = usePopup<string>()
  const deleteSubstitutionApplicationModal = usePopup<ISubstitutionRequest>()

  return (
    <>
      <PageHeader
        title={
          <Title level={4}>
            {t("assignations.substitution_request_other")}
          </Title>
        }
        hasBackButton={false}
      />
      {isLoading ? (
        <Loader />
      ) : data?.length === 0 ? (
        <Empty
          style={{
            marginTop: "var(--size-10)",
          }}
          description={t("global.no_x_found", {
            entity: t("assignations.substitution_request_one"),
            context: "female",
            count: 1,
          })}
        />
      ) : (
        <Space direction="vertical">
          {data?.map((substitutionRequest) => {
            const { id, event, application, displayed_application, person } =
              substitutionRequest

            return (
              <OverviewCardWithDate
                key={id}
                date={event?.start_date}
                actions={[
                  <Tag
                    style={{
                      marginRight: 0,
                    }}
                    color={statusTagColors(application)}
                  >
                    {displayed_application}
                  </Tag>,
                  <Button
                    style={{
                      width: "100%",
                    }}
                    icon={<CheckIcon height={12} />}
                    size="small"
                    type="text"
                    disabled={application !== "new"}
                    onClick={() => applyToSubstituteModal.open(id)}
                  />,
                  <Button
                    style={{
                      width: "100%",
                    }}
                    icon={<DeleteIcon height={17} />}
                    size="small"
                    type="text"
                    disabled={application !== "applied"}
                    onClick={() =>
                      deleteSubstitutionApplicationModal.open(
                        substitutionRequest
                      )
                    }
                  />,
                ]}
                Content={
                  <>
                    <p>{event?.name}</p>
                    <p>
                      {event?.start_hour}
                      {" - "}
                      {event?.end_hour}
                    </p>
                    <p>{event?.place?.name}</p>
                    <p>
                      {t("monitors.monitor")} : {person.name}
                    </p>
                  </>
                }
              />
            )
          })}
        </Space>
      )}
      <ApplyToSubstituteModal
        {...applyToSubstituteModal}
        open={applyToSubstituteModal.isOpen}
      />
      <DeleteSubstitutionApplicationModal
        {...deleteSubstitutionApplicationModal}
        open={deleteSubstitutionApplicationModal.isOpen}
      />
    </>
  )
}

export default SubstitutionRequests
